import React, { useState, useEffect } from "react";
import { Alert, Badge, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import PollSubmissionQuestionItem from "./PollSubmissionQuestionItem";
//import PollQuestionItem from "./PollQuestionItem";



const PollSubmissionQuestionsListing = ({ submissions }) => {
  return (
    <div className="activity-recent-registrations">
      <div className="card-primary mb-0">
        <Card.Header className="cardHead">
          <Card.Title>
            Submission(s){" "}
            {submissions
              ? "- Total " + submissions.length + " item(s)"
              : null}
          </Card.Title>
        </Card.Header>
        <Card.Body className="m-0 p-0">

          <>
            {!submissions || submissions.length <= 0 ? (
              <Alert variant="warning" className="m-0">
                No items found .
              </Alert>
            ) : (
              <>
                {submissions.map((question, index) => {
                  return <PollSubmissionQuestionItem question={question} />
                })}
              </>
            )}
          </>

        </Card.Body>
      </div>
    </div>
  );
};

export default PollSubmissionQuestionsListing;
